import React from 'react';
const ClientWebhookConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/client-webhook',
			component: React.lazy(() => import('./Webhook'))
		}
	]
};

export default ClientWebhookConfig;
